<script setup lang="ts">
import { useDisplayName } from '@/composables/useDisplayName';
import { dateToddMMMMyyyyHmm } from '@/utils/date.utils';
import { IGenericUser } from '@/interfaces';
import EditIcon from '@/assets/icons/EditIcon.vue';
import PlusCircleIcon from '@/assets/icons/PlusCircleIcon.vue';

defineProps<{
  creator: IGenericUser | null;
  createdAt: string;
  updater: IGenericUser | null;
  updatedAt: string;
}>();

const { getUserDisplayName } = useDisplayName();
</script>

<template>
  <div class="flex flex-col gap-sm">
    <div v-if="createdAt" class="flex gap-sm text-secondary text-footer items-center">
      <PlusCircleIcon class="size-icon-xs" />
      <span class="leading-none font-semibold">{{ $t('general.created') }}:</span>
      <span class="leading-none"
        >{{ creator ? getUserDisplayName(creator) : $t('auth.deletedUser') }},
        {{ dateToddMMMMyyyyHmm(createdAt) }}</span
      >
    </div>
    <div v-if="updatedAt" class="flex gap-sm text-secondary text-footer items-center">
      <EditIcon class="size-icon-xs" />
      <span class="leading-none font-semibold">{{ $t('general.updated') }}:</span>
      <span class="leading-none"
        >{{ updater ? getUserDisplayName(updater) : $t('auth.deletedUser') }},
        {{ dateToddMMMMyyyyHmm(updatedAt) }}</span
      >
    </div>
  </div>
</template>
